import LazyImport from './components/LazyImport'

export const approutes = [
  {
    path: '/',
    exact: true,
    component: LazyImport(() => import('./screens/Loads2' /* webpackChunkName: 'loads' */)),
  },
  {
    path: '/drivers',
    component: LazyImport(() => import('./screens/Drivers' /* webpackChunkName: 'drivers' */)),
    exact: true,
  },
  {
    path: '/driver/new',
    component: LazyImport(() => import('./screens/NewDriver' /* webpackChunkName: 'newDriver' */)),
    exact: true,
  },
  {
    path: '/driver/edit/:driverCPF',
    component: LazyImport(() => import('./screens/EditDriver' /* webpackChunkName: 'editDriver' */)),
    exact: true,
  },
  {
    path: '/vehicles',
    component: LazyImport(() => import('./screens/Fleet' /* webpackChunkName: 'fleet' */)),
    exact: true,
  },
  {
    path: '/vehicles/new',
    component: LazyImport(() => import('./screens/NewFleet' /* webpackChunkName: 'newFleet' */)),
    exact: true,
  },
  {
    path: '/vehicle/:vehicleId',
    component: LazyImport(() =>
      import('./screens/FleetDetails' /* webpackChunkName: 'fleetDetails' */),
    ),
    exact: true,
  },
  {
    path: '/vehicle/:vehicleId/third',
    component: LazyImport(() =>
      import('./screens/FleetDetails' /* webpackChunkName: 'fleetDetails' */),
    ),
    exact: true,
  },
  {
    path: '/vehicle/:vehicleId/:fleetType/edit',
    component: LazyImport(() => import('./screens/NewFleet' /* webpackChunkName: 'newFleet' */)),
    exact: true,
  },
  {
    path: '/loads',
    component: LazyImport(() => import('./screens/Loads2' /* webpackChunkName: 'loads' */)),
    exact: true,
  },
  {
    path: '/loads/new',
    component: LazyImport(() => import('./screens/NewLoads' /* webpackChunkName: 'newloads' */)),
    exact: true,
  },
  {
    path: '/old',
    component: LazyImport(() => import('./screens/Loads' /* webpackChunkName: 'loads' */)),
    exact: true,
  },
  {
    path: '/loads/:loadId/details',
    component: LazyImport(() =>
      import('./screens/LoadsDetails' /* webpackChunkName: 'loadDetails' */),
    ),
    exact: true,
  },
  {
    path: '/settings',
    component: LazyImport(() => import('./screens/Settings' /* webpackChunkName: 'settings' */)),
    exact: true,
  },
  {
    path: '/notifications',
    component: LazyImport(() =>
      import('./screens/Notifications' /* webpackChunkName: 'notifications' */),
    ),
    exact: true,
  },
  {
    path: '/messages',
    component: LazyImport(() => import('./screens/Messages' /* webpackChunkName: 'messages' */)),
    exact: true,
  },
  {
    path: '/invites',
    component: LazyImport(() => import('./screens/Invites' /* webpackChunkName: 'invites' */)),
    exact: true,
  },
  {
    path: '/loads/:loadId/details/batch/:batchid',
    component: LazyImport(() =>
      import('./screens/LoadsDetails' /* webpackChunkName: 'loadDetails' */),
    ),
    exact: true,
  },
  {
    path: '/incidents',
    component: LazyImport(() => import('./screens/Incidents' /* webpackChunkName: 'Incidents' */)),
    exact: true,
  },
  {
    path: '/incident/:id',
    component: LazyImport(() =>
      import('./screens/IncidentDetails' /* webpackChunkName: 'IncidentDetails' */),
    ),
    exact: true,
  },
  {
    path: '/loads/:loadId/details/delivery/:deliveryId',
    component: LazyImport(() =>
      import(
        './screens/LoadsDetails/components/BatchDeliveryDetails', /* webpackChunkName: 'BatchDeliveryDetails' */
      ),
    ),
    exact: true,
  },
  {
    path: '/loads/:loadId/details/grouped/:deliveryId',
    component: LazyImport(() =>
      import('./screens/LoadsDetails' /* webpackChunkName: 'loadDetailsGrouped' */),
    ),
    exact: true,
  },
  {
    path: '/deliveryhistory',
    component: LazyImport(() =>
      import('./screens/DeliveryLoadsHistory' /* webpackChunkName: 'deliveryHistory' */),
    ),
    exact: true,
  },
  {
    path: '/user-register',
    component: LazyImport(() =>
      import('./screens/UserRegistration' /* webpackChunkName: 'dispatchment' */),
    ),
    exact: true,
  },
  {
    path: '/pendings',
    component: LazyImport(() => import('./screens/Pendings' /* webpackChunkName: 'pendings' */)),
    exact: true,
  },
  {
    path: '/bids',
    component: LazyImport(() => import('./screens/Bids' /* webpackChunkName: 'bids' */)),
    exact: true,
  },
  {
    path: '/bids/:bidId',
    component: LazyImport(() =>
      import('./screens/BidDetails' /* webpackChunkName: 'bidDetails' */),
    ),
    exact: true,
  },
  {
    path: '/tollVouchers',
    component: LazyImport(() =>
      import('./screens/TollVouchers' /* webpackChunkName: 'tollVouchers' */),
    ),
    exact: true,
  },
  {
    path: '/freightTables',
    component: LazyImport(() =>
      import('./screens/FreightTables' /* webpackChunkName: 'freightTables' */)
    ),
    exact: true,
  },
  {
    path: '/freightTables/:id/routes',
    component: LazyImport(() =>
      import('./screens/FreightTableRoutes' /* webpackChunkName: 'freightTableRoutes' */)
    ),
    exact: true,
  },

]

export default approutes
